module.exports = __webpack_public_path__ + "media/img/cart-confirmed-4af57bcc3eb4bead46ef6fb6bbf5f20e.png";